import scrollToPersonalForm from "../../scrollToPersonalForm"
import { DLClickEventExtended } from "../DLEvents"

const handleClickHeader = (
  name: "sticky" | "click_cta",
  placement: "header" | "burger_menu",
  urlForButtonRedirect?: string
) => {
  DLClickEventExtended({ name, placement, eventCategory: "click_cta", eventAction: "Стики-кнопка" })

  if (urlForButtonRedirect) {
    window.open(urlForButtonRedirect, "_blank")
  } else {
    scrollToPersonalForm()
  }
}

export { handleClickHeader }
